import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";
import { Table, Card } from "@cofano/cck";
import { FormattedDate } from "utils/DateUtils";
import { GetAdminFaqSearchTermsDocument } from "__generated__/view/admin/graphql/admin.queries.generated";

const AdminSupportSearchTerms = () => {

	const { data, loading } = useQuery(GetAdminFaqSearchTermsDocument);

	return (
		<Card title={intl.formatMessage({ id: "ADMIN_FAQ_SEARCH_TERMS_TITLE" })}>
			<Table
				id="adminSupportSearchTerms"
				disableFooter
				contentLoading={loading}
				content={data?.adminFaqSearchTerms ?? []}
				columns={[ {
					id: "searchTerm",
					title: intl.formatMessage({ id: "ADMIN_FAQ_SEARCH_TERM_LABEL" }),
				}, {
					id: "count",
					title: intl.formatMessage({ id: "ADMIN_FAQ_COUNT_LABEL" }),
				}, {
					id: "lastSearchedOn",
					title: intl.formatMessage({ id: "ADMIN_FAQ_LAST_SEARCHED_ON_LABEL" }),
					render: (row) => <FormattedDate date={row.lastSearchedOn} withoutYear />,
				} ]} />
		</Card>
	);
};

export default AdminSupportSearchTerms;
